import Vue from 'vue'

import GlobalMixin from '@/mixins/global'
import MessageMixin from '@/mixins/message'
import DateFormatMixin from '@/mixins/date-format'

Vue.mixin(GlobalMixin)
Vue.mixin(MessageMixin)
Vue.mixin(DateFormatMixin)
